module.exports = __webpack_public_path__ + "img/carita_feliz_blue.4de24735.webp";